import { setTimeout } from 'core-js/web/immediate';
import React, { useRef, useState, useEffect, useMemo } from 'react';
import PanelCollapse from './PanelCollapse';

const PanelBody = ({
  className,
  children,
  collapsible,
  current,
  expanded,
  eventKey,
  onChange,
  onToggle,
  forwardedRef,
  defaultActiveKey,
  ...props
}) => {
  const heightRef = useRef();
  const isActive = expanded || current === eventKey;
  const [opened, setOpened] = useState(false);

  useEffect(() => {
    let openTimer;
    if (isActive) {
      openTimer = setTimeout(() => {
        setOpened(true);
      }, 400);
    } else {
      openTimer = setTimeout(() => {
        setOpened(false);
      }, 50);
    }
    return () => {
      clearTimeout(openTimer);
    };
  }, [isActive]);

  const heightVal = useMemo(() => {
    if (opened && isActive) return 'auto';
    if (!opened && !isActive) return '0px';
    if ((isActive && !opened) || (!isActive && opened))
      return `${heightRef?.current?.scrollHeight}px`;
    return '0px';
  }, [opened, isActive, heightRef.current]);

  return collapsible ? (
    <PanelCollapse
      style={{
        height: heightVal,
        overflow: 'hidden',
      }}
    >
      <div className={`panel-body ${className || ''}`} {...props} ref={heightRef}>
        {children}
      </div>
    </PanelCollapse>
  ) : (
    <div
      className={className}
      style={{ height: 'auto' }}
      {...props}
      ref={forwardedRef || heightRef}
    >
      {children}
    </div>
  );
};

export default PanelBody;
